import * as SimpleBar from "simplebar";

import FlatsPage from "./flats-page";
import toggleLocales from "./toggle-locales";

import modalFloors from "./modal-floors";
import modalGallery from "./modal-flat-gallery";
import modalFlatPlan from "./modal-flat-plan";
import modalHousePlan from "./modal-house-plan";
import modalMezzanine from "./modal-mezzanine";
import modalForm from "./modal-form";
import modalPanorama from "./modal-panorama";
import modal3dTour from "./modal-3d";
import modalVideo from "./modal-video";
import modalTrezini from "./modal-trezini";
import { youtubeLinkToEmbed } from "./utils";

const classNames = {
  controls: {
    controlActive: `flat-page__info--active`,
  },
  plans: {
    planVisible: `flat-page__plan--active`,
  },
};

export default class FlatsItemPage extends FlatsPage {
  constructor() {
    super();
    this.container = this.page.querySelector(`.flat-page`);
    this.slug = this.page.querySelector(`.wrapper`).dataset.slug;
    this.plansControls = [...this.page.querySelectorAll(`.js-gallery-control`)];
    this.plans = [...this.page.querySelectorAll(`.flat-page__plan`)];
    this.description = this.container.querySelector(`.flat-page__description`);
    this.panoramaLink = this.container.querySelector(`.js-modal-panorama`);
    this.link3d = this.container.querySelector(`.js-modal-3d`);
    this.video = this.container.querySelector(`.js-modal-video`);
  }

  init = (locale) => {
    super.init(locale);
    this.loadFlatData();
    this.bindHandlers();
    if (this.plansControls.length) {
      this.setInitialControlsState();
    }
    new SimpleBar(this.description);
    toggleLocales();
  };

  loadFlatData = () => {
    const source = `/flats/${this.slug}/flat_data`;

    this.loadData(source, (data) => {
      this.createModals(data);
    });
  };

  bindHandlers() {
    this.plansControls.forEach((control) =>
      control.addEventListener(`click`, this.toggleControlsState(true))
    );
    this.container.addEventListener(`click`, (ev) => {
      if (ev.target.classList.contains(`flat-page__option`)) {
        ev.preventDefault();
      }
    });

    if (this.video)
      this.video.addEventListener(`click`, () => {
        $(".modal-video iframe").attr(
          "src",
          youtubeLinkToEmbed(this.video.dataset.video)
        );
      });
  }

  setInitialControlsState() {
    const firstFloor = this.plansControls[0];

    firstFloor.classList.add(classNames.controls.controlActive);
    this.togglePlansState(firstFloor.dataset.floor);
  }

  toggleControlsState = (state) => (ev) => {
    const {
      controls: { controlActive },
    } = classNames;

    ev.preventDefault();

    this.plansControls.forEach((control) =>
      control.classList.toggle(controlActive, !state)
    );
    ev.target.classList.toggle(classNames.controls.controlActive, state);
    this.togglePlansState(ev.target.dataset.floor);
  };

  togglePlansState = (floor) => {
    this.plans.forEach((plan) =>
      plan.classList.remove(classNames.plans.planVisible)
    );
    this.plans
      .find((plan) => plan.dataset.floor === floor)
      .classList.add(classNames.plans.planVisible);
  };

  createModals(data) {
    if (data[`floors`].length) {
      modalFloors.init(data[`floors`], this.locale);
      modalFlatPlan.init(data[`floors`]);
    }

    if (data[`galleries`].length) {
      modalGallery.init(data[`galleries`]);
    }

    if (data[`plans`]) {
      modalHousePlan.init(data, this.locale);
    }

    if (data[`mezzanine`]) {
      modalMezzanine.init(data);
    }

    if (data[`link_to_panorama`]) {
      this.panoramaLink.setAttribute(
        "data-panorama-img",
        data[`link_to_panorama`]
      );
      modalPanorama.init({
        container: () => document.querySelector("div.panorama"),
        wrapperClass: ".flat-page__options--3d",
        itemClass: ".js-modal-panorama",
        onShow: (event, _pano) => {
          return event.currentTarget.dataset.panoramaImg;
        },
      });
    }

    if (data[`link_to_3d`]) {
      modal3dTour.init(this.link3d);
    }

    if (this.video) {
      modalVideo.init();
    }

    modalForm.init();
    modalTrezini.init();
  }
}
